import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { KonPermission } from 'app/modules/UIKit/components/kontable/utility/utility-model';
import { ClassificationDetail } from '../../../models/classification.model';
import { DataTableService } from '../../../modules/UIKit/components/dataTable/dataTable.service';
import { DataTableCustomButton } from '../../../modules/UIKit/components/dataTable/dataTableCustomButton.interface';
import { DataTableField } from '../../../modules/UIKit/components/dataTable/dataTableField.interface';
import { ClassificationService } from '../../../services/classification/classification.service';

@Component({
  selector: 'app-common-classification-details',
  templateUrl: './classification-details.component.html'
})

export class ClassificationDetailsComponent implements OnInit {

  @Output() onBackClick: EventEmitter<any> = new EventEmitter();
  @Input() idDetails: number;

  titles: DataTableField[];
  customButtons: DataTableCustomButton[];
  public perm: KonPermission = new KonPermission();
  modalTitle = '';
  labels = {};

  constructor (
    public svc: ClassificationService,
    private translate: TranslateService,
    private srvDataTable: DataTableService) {

      this.translate.get([
        'common.classification_details_code',
        'common.classification_details_desc',
        'common.back'
      ]).subscribe((res) => {
        console.log(res);
        this.titles = [
          { id: 'id', label: '#' },
          { id: 'code', label: res['common.classification_details_code'], editable: true },
          { id: 'description', label: res['common.classification_details_desc'], editable: true }
        ];

        this.customButtons = [{
          callbackname: 'back',
          isAlwaysEnabled: true,
          label: res['common.back'],
          icon: 'fa fa-angle-double-left'
        }]

      });

  }

  ngOnInit() {
    this.svc.getDetails(this.idDetails).subscribe();

    this.translate.get([
      'classificationDetailList.add_title'
    ]).subscribe((res) => {
      this.labels['add_title'] = res['classificationDetailList.add_title'];
    });

    this.perm.edit = false;
    this.perm.view = false;

  }

  refresh() {
    this.svc.getDetails(this.idDetails).subscribe();
  }

  onEditInline(event) {
    this.svc.putDetails(event).subscribe();
    this.svc.editingDetail = null;
    this.refresh();
  }

  onDeleteInline(event) {
    this.svc.deleteDetail(event).subscribe();
    this.refresh();
  }

  onAdd(event) {
    event.classification_id = this.idDetails;
    this.svc.postDetails(event).subscribe( () => {
      this.svc.editingDetail = null;
      this.srvDataTable.get('dt_classification_details').showDetail = false;
      this.refresh();
    });
  }

  showAddDialog(data) {
    this.modalTitle = this.labels['add_title'];
    this.svc.editingDetail = new ClassificationDetail();
  }

  onCustomButton(event) {
    switch (event.callbackName) {
      case 'back':
        this.onBackClick.emit();
        break;
    }
  }

  onDialogHide () {
    this.svc.editingDetail = null;
  }

}



// WEBPACK FOOTER //
// ./src/app/views/classification/classification-details/classification-details.component.ts